import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';

import getMetaTags from 'components/common/meta-tags';
import AftercareListing from 'components/layouts/aftercare';
import { IAftercareLandingPage } from 'components/layouts/aftercare/types';
import { IProps } from 'components/layouts/aftercare/types';
import { filterDataToSingleItem } from 'framework/sanity/filter-data-to-single-item';
import { mapBlocks } from 'framework/sanity/map-blocks';
import { aftercareLandingPageQuery } from 'framework/sanity/queries/genus';
import { getClient } from 'framework/sanity/sanity-client';
import { aggregateSanityArticlePreview } from 'utils/articles';
import { setCacheControlOneHour } from 'utils/cache';

export default function AftercareLandingPage(props: IProps) {
  const {
    data: { page },
  } = props;

  return (
    <>
      <Head>{getMetaTags({ meta: page.meta })}</Head>
      <AftercareListing {...props} />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  preview = false,
  res,
}) => {
  setCacheControlOneHour(res);

  const data = await getClient().fetch<IAftercareLandingPage[]>(
    aftercareLandingPageQuery,
  );

  const page = filterDataToSingleItem(data);

  if (!page) {
    return {
      notFound: true,
    };
  }

  const blocks = await mapBlocks(page.blocks || []);

  const relatedContent = page.relatedContent?.map((item) => {
    if (item._type === 'cta') return item;

    return {
      ...item,
      article: aggregateSanityArticlePreview(item.article),
    };
  });

  return {
    props: {
      preview,
      data: {
        page: {
          ...page,
          blocks,
          relatedContent,
        },
      },
    },
  };
};
